import React from 'react';
import { Container, Heading } from './Section';
import { Button } from './Button';
type Props = {
  title: string;
  text: string;
  primaryLabel: string;
  secondaryLabel?: string;
  location: string;
  service?: string;
};
export function CtaBand({
  title,
  text,
  primaryLabel,
  secondaryLabel = 'Hablar con un especialista',
  location,
  service
}: Props) {
  const query = service ? `?servicio=${encodeURIComponent(service)}` : '';
  return <section className="bg-brand-800" data-id="element-446" data-mp="v4bxm3v2on0q">
      <Container className="py-16 md:py-20" data-id="element-447" data-mp="r16x26ujyveq">
        <div className="grid items-end gap-8 lg:grid-cols-[1.4fr_1fr]" data-id="element-448" data-mp="r0dwxoq3n45k">
          <div data-id="element-449" data-mp="m1kjfwatbd5e">
            <Heading as="h2" size="md" tone="dark" data-id="element-450" data-mp="m35dlkt7su2q">
              {title}
            </Heading>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-mist-200" data-id="element-451" data-mp="h4156we470dg">{text}</p>
          </div>
          <div className="flex flex-wrap gap-3 lg:justify-end" data-id="element-452" data-mp="2gf267h3e85zd">
            <Button to={`/contacto${query}`} variant="primary" size="lg" trackingLocation={location} withArrow className="bg-accent-500 hover:bg-accent-400 text-graphite-900" data-id="element-453" data-mp="2bha7o488tlm7">
              {primaryLabel}
            </Button>
            <Button to="/contacto#especialista" variant="onDark" size="lg" trackingLocation={location} data-id="element-454" data-mp="2t8q892tg1jf6">
              {secondaryLabel}
            </Button>
          </div>
        </div>
      </Container>
    </section>;
}